import { render, staticRenderFns } from "./headerUpdate.vue?vue&type=template&id=b540553a"
import script from "./headerUpdate.vue?vue&type=script&lang=js"
export * from "./headerUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports